<div class="row fids-bs-row">
  <div class="col-sm-12 m-b-10 fids-o-p-l">
    <div class="fids-timeline-header" style="background-color:transparent;">
      <strong>{{title}}</strong>
      <div class="dropdown-divider" style="width: 390px"></div>
    </div>
    <div class="mdc-card" style="margin-top:-14px;width: 400px;overflow:hidden;">
      <ng-content>

      </ng-content>
    </div>
  </div>
</div>
